import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
import { OutletModule, OutletRefModule, PageLayoutModule, PageSlotModule, SpinnerModule } from '@spartacus/storefront';
import { CookieService } from 'src/app/customServices/cookie.service';
import { CountrySelectorService } from 'src/app/customServices/country-selector.service';
import { CustomerIdComponent } from '../customer-id/customer-id.component';
import { KbCountryFlagComponent } from '../kb-country-flag/kb-country-flag.component';
import { KbGlobalMessageComponentModule } from '../kb-global-message/kb-global-message.module';
import { KbHeaderLanguageComponent } from '../kb-header-language/kb-header-language.component';
import { KbMyAccountLeftSideNavModule } from '../kb-myAccount/my-account-left-sidenav/my-account-left-sidenav.module';
import { HeaderComponent } from './header.component';
import { KbScrollableheaderComponent } from './kb-scrollableheader/kb-scrollableheader.component';
import { KbHeaderLanguageModule } from '../kb-header-language/kb-header-language.module';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { KbNotificationsModule } from "../kb-Notifications/kb-notifications/kb-notifications.module";

import { KBLoginFormComponentService } from '../kb-login/login-form-component.service';

@NgModule({
  imports: [
    CommonModule,
    PageLayoutModule,
    OutletModule,
    OutletRefModule,
    PageSlotModule,
    SpinnerModule,
    I18nModule,
    FormsModule,
    KbGlobalMessageComponentModule,
    KbMyAccountLeftSideNavModule,
    KbHeaderLanguageModule,
    MatInputModule,
    MatSelectModule,
    KbNotificationsModule
  ],
  providers: [CountrySelectorService, CookieService, KBLoginFormComponentService],
  declarations: [
    HeaderComponent,
    KbCountryFlagComponent,
    CustomerIdComponent,
    KbScrollableheaderComponent,
  ],
})
export class HeaderModule { }
